module.exports = __webpack_public_path__ + "img/camera.3376df3d.png";